/* ============================================================
   AGE-GATE.JS — Qualification chercheur via localStorage
   ============================================================ */
(function () {
  'use strict';

  const STORAGE_KEY = 'age_gate_passed';
  const overlay = document.getElementById('age-gate');
  if (!overlay) return;

  const passed = localStorage.getItem(STORAGE_KEY);
  if (passed === 'true') return;

  /* Show modal */
  overlay.classList.add('is-open');
  overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';

  const acceptBtn = overlay.querySelector('[data-age-gate-accept]');
  const denyBtn = overlay.querySelector('[data-age-gate-deny]');
  const checks = overlay.querySelectorAll('[data-age-gate-check]');

  /* Enable accept button only when all checked */
  const updateAcceptState = () => {
    const allChecked = Array.from(checks).every(c => c.checked);
    acceptBtn.disabled = !allChecked;
  };
  checks.forEach(c => c.addEventListener('change', updateAcceptState));

  /* Accept */
  acceptBtn.addEventListener('click', () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  });

  /* Deny → redirect to neutral page */
  denyBtn.addEventListener('click', () => {
    window.location.href = 'https://www.google.com';
  });
})();
